import React from 'react';

const TestimonialCardSkeleton = () => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden animate-pulse">
      <div className="p-5">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 rounded-xl bg-gray-200" />
          <div className="h-4 w-24 bg-gray-200 rounded" />
        </div>
        <div className="h-4 bg-gray-200 rounded w-full mb-2" />
        <div className="h-4 bg-gray-200 rounded w-3/4 mb-3" />
        <div className="h-3 bg-gray-200 rounded w-full mb-1" />
        <div className="h-3 bg-gray-200 rounded w-5/6 mb-1" />
        <div className="h-3 bg-gray-200 rounded w-4/6" />
      </div>
      <div className="px-5 py-3 bg-gray-50 border-t border-gray-100">
        <div className="h-3 w-24 bg-gray-200 rounded mb-1" />
        <div className="h-3 w-16 bg-gray-200 rounded" />
      </div>
      <div className="flex gap-2 p-4 border-t border-gray-100">
        <div className="flex-1 h-9 bg-gray-200 rounded-lg" />
        <div className="flex-1 h-9 bg-gray-200 rounded-lg" />
        <div className="flex-1 h-9 bg-gray-200 rounded-lg" />
      </div>
    </div>
  );
};

export default TestimonialCardSkeleton;